<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="9"
    viewBox="0 0 6 9"
  >
    <path
      fill="none"
      fill-rule="evenodd"
      stroke="#FFF"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M0 3L3.5 7 7 3"
      transform="matrix(0 -1 -1 0 8 8)"
    />
  </svg>
</template>